import { Banner, CareerImage } from "../images/index";
import {
  CareerGrowth,
  GlobalOpportunities,
  InclusiveDiverse,
  InnovationDriven,
  Slider1,
  Slider2,
  Location,
  Time,
  Slider3,
  Slider4,
  Slider5,
  Slider6,
  Slider7,
  Slider8,
  Slider9,
  Slider10,
  Slider11,
  Slider12,
} from "../images/Careers/index";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useRef, useState, useMemo, useEffect } from "react";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getJobs, getPagesBySlug } from "../services/apiService";
import useSlug from "./SlugComp";
import SEO from "./Seo";

const images = [
  Slider2,
  Slider3,
  Slider1,
  Slider4,
  Slider5,
  Slider6,
  Slider7,
  Slider8,
  Slider9,
  Slider10,
  Slider11,
  Slider12,
];

const features = [
  {
    icon: GlobalOpportunities,
    title: "Global Opportunities",
    desc: "Work with U.S. and India hybrid teams across diverse industries.",
  },
  {
    icon: InclusiveDiverse,
    title: "Inclusive & Diverse",
    desc: "A women-owned business committed to equality, collaboration, and respect.",
  },
  {
    icon: InnovationDriven,
    title: "Innovation-Driven",
    desc: "AI, ML, automation, and product engineering projects that push boundaries.",
  },
  {
    icon: CareerGrowth,
    title: "Career Growth",
    desc: "Learning programs, mentoring, and leadership opportunities.",
  },
];

function Careers() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeDot, setActiveDot] = useState(0);
  const totalDots = 12;
  const sliderRef = React.useRef(null);
  const sectionRef = useRef(null);
  const [search, setSearch] = useState("");
  const [location, setLocation] = useState("");
  const [type, setType] = useState("");
  const navigate = useNavigate();
  const [jobsData, setJobsData] = useState([]);
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();
  const locations = [
    { name: "USA", code: "USA" },
    { name: "India", code: "INDIA" },
  ];

  const jobTypes = [
    { name: "Full-time" },
    { name: "Remote" },
    { name: "Hybrid" },
  ];

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "60px",
    autoplay: true,
    autoplaySpeed: 2000,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
      setActiveDot(Math.floor(newIndex / 1));
    },
  };

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const data = await getJobs();
        setJobsData(data.data);
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);

  const dotClick = (index) => {
    setActiveDot(index);
    sliderRef.current.slickGoTo(index);
  };

  const scrollToSection = () => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const navToRecruitment = (job) => {
    navigate("/Careers/Hire", { state: { job } });
  };

  const filteredJobs = useMemo(() => {
    return jobsData.filter((job) => {
      const matchesSearch = job.title
        .toLowerCase()
        .includes(search.toLowerCase());
      const matchesLocation =
        !location || location === "Location" || job.country === location?.name;
      const matchesType =
        !type || type === "Type" || job.jobType === type?.name;
      return matchesSearch && matchesLocation && matchesType;
    });
  }, [search, location, type, jobsData]);

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-4 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-2xl font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  CAREERS
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Build the Future of Technology With Us
              </h1>
              <p className="text-md text-[#404040]">
                At TechProjects, we’re more than just a workplace—we’re a
                community of innovators, problem solvers, and change-makers.
              </p>
              <button
                onClick={scrollToSection}
                type="submit"
                className="bg-activeColor mt-12 text-white text-lg md:text-xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                View Open Positions{" "}
                <i className="fa fa-arrow-right text-xs mt-1"></i>
              </button>
            </div>

            <div className="max-w-xl flex justify-end mt-[6rem]">
              <img
                src={CareerImage}
                alt="IT Hiring"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        <section className="py-20 bg-white px-6 md:px-10 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
            <div className="mb-12">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-3">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] mb-8">
                Why Join Us?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-x-16 md:gap-y-12">
              {features.map((item, index) => (
                <div key={index} className="flex gap-5 items-center">
                  <div className="flex-shrink-0">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl text-[#0F172A] mb-2">
                      {item.title}
                    </h3>
                    <p className="font-400 text-[#0F172A] text-lg leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-12 bg-white font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-6 md:px-0">
            <div className="mb-8">
              <div className="grid space-y-6 items-center mb-2">
                <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                </span>
                <h2 className="text-7xl font-extrabold text-[#434253">
                  Life at <span className="text-gray-900">TechProjects</span>
                </h2>
              </div>
              <p className="text-[#404040] font-400 mt-4 text-lg">
                We celebrate ideas, encourage experimentation, and support our
                people’s personal and professional growth. From flexible work
                environments to global delivery exposure, your career journey
                with us is limitless.
              </p>
            </div>
          </div>

          <div className="">
            <Slider ref={sliderRef} {...settings}>
              {images.map((i) => (
                <div key={i} className="px-2">
                  <img
                    src={i}
                    alt={`slide-${i}`}
                    className="w-full h-[346px] object-cover"
                  />
                </div>
              ))}
            </Slider>
            <div className="flex justify-center items-center space-x-4 mt-6">
              <button
                onClick={() => sliderRef.current.slickPrev()}
                className="w-10 h-10 flex items-center justify-center bg-white shadow rounded-full hover:bg-gray-300"
              >
                <i className="fa fa-chevron-left" aria-hidden="true"></i>
              </button>

              <div className="flex space-x-3">
                {Array.from({ length: totalDots }).map((_, i) => (
                  <button
                    key={i}
                    onClick={() => dotClick(i)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      i === activeDot ? "bg-[#062B96]" : "bg-[#D4E5FF]"
                    }`}
                    aria-label={`Go to slide ${i}`}
                  />
                ))}
              </div>

              <button
                onClick={() => sliderRef.current.slickNext()}
                className="w-10 h-10 flex items-center justify-center bg-white shadow rounded-full hover:bg-gray-300"
              >
                <i className="fa fa-chevron-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </section>
        <section
          className="bg-[#F7F7F7] py-10 md:py-16 font-roboto"
          ref={sectionRef}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-6 md:px-0 space-y-14">
            <div className="mb-7">
              <div className="flex gap-2 items-center mb-2">
                <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                  <span className="w-[21px] h-[6px] bg-activeColor"></span>
                  <span className="w-[36px] h-[6px] bg-activeColor"></span>
                  <span className="text-[#475569]">WE ARE HIRING</span>
                </span>
              </div>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] mb-3">
                Join our team
              </h2>
              <p className="text-[#404040] font-400 text-sm md:text-lg mt-2">
                Our philosophy is simple — hire a team of diverse, passionate
                people and foster a culture that empowers you to do your best
                work.
              </p>
            </div>

            <div className="flex flex-col md:flex-row bg-white rounded-lg overflow-hidden border items-center mb-8">
              <div className="flex-1 border-b md:border-b-0 md:border-r border-gray-200">
                <input
                  className="w-full p-4 outline-none text-[#5F6870]"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="flex-1 border-b md:border-b-0 md:border-r border-gray-200">
                <Dropdown
                  value={location}
                  onChange={(e) => setLocation(e.value)}
                  options={locations}
                  optionLabel="name"
                  placeholder="Location"
                  className="w-full p-dropdown-sm"
                  highlightOnSelect={false}
                />
              </div>

              <div className="flex-1 border-b md:border-b-0 md:border-r border-gray-200">
                <Dropdown
                  value={type}
                  onChange={(e) => setType(e.value)}
                  options={jobTypes}
                  optionLabel="name"
                  placeholder="Type"
                  className="w-full p-dropdown-sm"
                  highlightOnSelect={false}
                />
              </div>
            </div>

            <div className="bg-white shadow">
              {filteredJobs.length > 0 ? (
                filteredJobs.map((job, i) => (
                  <div
                    key={job.title}
                    className={`grid grid-cols-1 md:grid-cols-5 items-center gap-2 px-4 py-5 border-b last:border-0 ${
                      i % 2 === 0 ? "bg-[#F1F5F9]" : "bg-white"
                    }`}
                  >
                    <div className="font-500 text-2xl text-[#0F172A] md:col-span-2">
                      {job.title}
                    </div>

                    <div className="flex items-center gap-2 text-[#5F6870] font-500 text-md">
                      <img src={Location} alt="Location" />
                      <span>{job.country}</span>
                    </div>

                    <div className="flex items-center gap-2 text-[#5F6870] font-500 text-md">
                      <img src={Time} alt="Time" />
                      <span>{job.jobType}</span>
                    </div>

                    <div className="flex justify-end">
                      <button
                        onClick={() => navToRecruitment(job)}
                        className="bg-activeColor text-white font-500 text-md px-5 py-2 rounded shadow hover:bg-red-600 transition"
                      >
                        View Job
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-6 text-center text-gray-500">
                  No jobs found matching your criteria.
                </div>
              )}
            </div>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Careers;
